import { Avatar } from '@material-ui/core';
import type { Currency } from '@ps/web-core-enums';
import classNames from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

import flags from '@swf/core/assets/flags';

import { isZeroExponentCurrency } from '../../utils/cashier';

import { avatar, convertedAmount, currencyInfo } from './ConversionCurrency.scss';

interface Props {
  amount: number;
  balanceCurrency: Currency;
  className?: string;
}

const ConversionCurrency: React.FC<Props> = ({ amount, balanceCurrency, className }) => {
  const { formatNumber } = useIntl();
  const zeroExponentCurrency = isZeroExponentCurrency(balanceCurrency);

  const convertedValue = formatNumber(amount, {
    currency: balanceCurrency,
    style: 'currency',
    currencyDisplay: 'code',
    maximumFractionDigits: zeroExponentCurrency ? 0 : 2,
    minimumFractionDigits: zeroExponentCurrency ? 0 : 2
  })
    .replace(balanceCurrency, '')
    .trim();

  return (
    <div className={classNames(currencyInfo, className)}>
      <span className={convertedAmount}>{convertedValue}</span>
      <Avatar classes={{ root: avatar }} src={flags[balanceCurrency.substring(0, 2)]} />
      {balanceCurrency}
    </div>
  );
};

export default ConversionCurrency;
